/*
* Document Manager
* Author: @thinkdj
* Date: 01 Aug 2019
* I/p: requirementDO[]
* O/p: requirementDO[], documentDO[]
* Desc: Document Manager handles segregating, uploading, previewing, downloading and permissioning of files
*/

import {
  Component, OnInit, Input, Output, EventEmitter, ViewContainerRef, OnDestroy,
  OnChanges, SimpleChanges, SimpleChange
} from '@angular/core';
import { map } from 'rxjs/operators';
import { environment } from 'environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import {
  ValidationUtilService,
  ApiRequestService,
  LookupDataService,
  CommonUtilty,
  I18nService,
  MultiLingualService,
  InteractService,
  ComponentOutputDO,
  RequirementDO,
  /* Document Manager */
  AppConfig,
  EntityDocumentDO,
  AppMetadataHandler,
  UserInfoService,
} from 'app';
import { AbstractControl, FormBuilder, FormControl, FormGroup, FormArray, Validators } from '@angular/forms';

/* Document Manager */
import { HttpRequest, HttpClient, HttpEventType, HttpEvent, HttpResponse, HttpHeaders } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { NzUploadFile } from 'ng-zorro-antd/upload';
import { forkJoin, Observable, Observer, Subject } from 'rxjs';
import { debounceTime, filter } from 'rxjs/operators';
//import {RequestMethod, ResponseContentType} from '@angular/http';
import { DomSanitizer } from '@angular/platform-browser';
import { DocumentManagerDataService } from './document-manager-data.service';
import { ErrorDO } from '../../../BaseFramework/shared/models/error.model';

import * as moment from 'moment/moment';
import { DataTransformService } from 'app/ViewModules/shared-services';
import { DocumentValidatorService } from 'app/BaseFramework/core/services/document-validator/document-validator.service';
import { Constants } from 'app/constants';

declare var Tiff: any;

export interface documentOutput {
  requirementDOs: Array<any>,
  entityDocumentDOs: Array<any>
}

interface ValidationOutput {
  isInvalid: boolean,
  errorDOs: Array<ErrorDO>
}

@Component({
  selector: 'app-document-manager',
  templateUrl: './document-manager.component.html',
  styleUrls: ['./document-manager.component.scss']
})

export class DocumentManagerComponent implements OnInit, OnChanges, OnDestroy {

  //<editor-fold desc="I/O">
  _currentComponentName = 'DocumentManagerComponent';
  @Output() componentOutput = new EventEmitter<any>();
  _requirements;
  @Input()
  set requirements(value: any) {
    this._requirements = value;
    //this.initDocumentData(this._inputDataForEdit, this._requirements);
  };
  get requirements() {
    return this._requirements
  }

  //@Input() TransactionState: Array<any>;
  @Input() transactionState: string;

  private _inputDataForEdit;
  @Input()
  set inputDataForEdit(value: any) {
    this._inputDataForEdit = value
  };
  get inputDataForEdit() {
    return this._inputDataForEdit;
  }
  @Input() RequirementEntityGuid: any;
  io: any = null;
  ioNominees: any = null;
  ioClients: any = null;
  ioStartDate: any = null; // Intimation Date (for date check)

  /* ====== MINI MODE () ===== */
  @Input() mode = "big";
  @Input() heading: string = 'No heading provided'; // this will be used as heading in mini mode
  @Input() headingType: 'heading' | 'label' = 'heading'; // Heading or label for heading text
  /* If it is client specific */
  @Input() clientRefGuid: any = null;
  @Input() clientDO: any = null;
  @Input() clientDOHM: any = null;

  /*  ====== Configs ====== */
  @Input() readonly: boolean = false;
  @Input() coreComponent: boolean = false; /* if Core, its EMITS() data to parent */
  @Input() enableDownload: boolean = true;
  @Input() entity: 'claim' | 'policy' = 'policy'; // Loose docs would be named as per primary entity
  @Input() visibility: 'public-only' | 'all' = 'all'; // Public-only will list only public files

  @Input() subTransactionGuids = []; // For Investigator flitering
  @Input() documentManagerExpanded: boolean = false;
  @Input()collaborationGuid;

  /* Show only 'public' documents for these roleCds */
  externalUsers: Array<string> = ["CLAIM_INVESTIGATION"];  // 'RoleCd's of all external users go here ,"SR_EXECUTIVE"

  /* App config vars & defaults */
  defaultVisibilityCd: string = "INTERNAL"; // This will be used as default for NEW upload and NEW requirement
  defaultVisibilityCdExternalUser: string = "EXTERNAL"; // This will be used as default for NEW upload and NEW requirement for an EXTERNAL USER
  defaultStatusCd: string = "IDENTIFIED";   // This will be used as default for NEW requirement
  userIsExternal: boolean = false;
  notSupportedText: string = "Please download document to view contents"; // Default text for non-supported file types. Use i18n

  //</editor-fold>

  /* Zero State */
  docManZeroState = {
    title: "No Requirements",
    message: "Please save to generate requirements",
    icon: 'paper-clip'
  };

  documentsFromServer: any; //complete list of documents from server (guid fetch)
  documentsFromServerMini: any; //complete list of documents from server (guid fetch) BACKUP as first loop filters above var
  documents: any;
  isReady: boolean = false;
  isProd: boolean = environment.production;
  looseDocsKey: string = 'LOOSE_DOCUMENTS';

  /* Internally used */
  documentCollection: any = []; /* this is filtered and emitted */
  documentCollectionLoose: any = [];

  /* Dropdowns */
  looseDocNewType: any = null;
  documentTypeCdDrodownCache: any;
  documentSubTypeCdDrodownCache: any;

  /* Internal */
  UiFilesList: any[] = []; // Must be array

  constructor(
    /* Framework */
    private viewContainerRef: ViewContainerRef,
    private validationUtilService: ValidationUtilService,
    private apiRequestService: ApiRequestService,
    private route: ActivatedRoute,
    private router: Router,
    private fb: FormBuilder,
    private commonUtilty: CommonUtilty,
    private i18nService: I18nService,
    private multiLingualService: MultiLingualService,
    private translateService: TranslateService,
    private lookupDataService: LookupDataService,
    private interactService: InteractService,
    private userInfoService: UserInfoService,
    /* Document Manager */
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private msg: NzMessageService,
    private appConfig: AppConfig,
    public appMetadataHandler: AppMetadataHandler,
    private docManDataService: DocumentManagerDataService,
    private dataTransformService: DataTransformService,
    public documentValidatorService: DocumentValidatorService
  ) {
  }

  //<editor-fold desc="Framework">
  EmitComponentOutput(data) {
    let c = new ComponentOutputDO(this.getCurrentComponentName(), data, this.componentOutput)
  }
  getParentComponent(): Component {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component
    } catch { }
  }
  getParentComponentName(): string {
    try {
      return this.viewContainerRef['_data'].componentView.component.viewContainerRef['_view'].component.constructor.name
    } catch { }
  }
  getCurrentComponentName(): string {
    return this._currentComponentName
  }

  parentEvent$;
  subscribeToParentEvent() {
    if (this.parentEvent$ != null)
      this.parentEvent$.unsubscribe();
    this.parentEvent$ = this.interactService.pingSubject$.subscribe((param: any) => {

      /* Validation */
      let isOutputValid = this.validateOutput();

      /* Decide: shouldEmit? */
      if (isOutputValid && !this.readonly && this.mode != 'mini' && this.coreComponent) {
        /* Create DocMan component's `output` */
        let requirementDOs = this.extractRequirementDOs();
        let documentDOs = this.extractDocumentDOs();
        let output: documentOutput = { requirementDOs: requirementDOs, entityDocumentDOs: documentDOs };
        /* If user has not clicked 'save' and there are unsaved changes, save */
        if (this.dataChanged) this.saveReqsAndDocs();
        /* EMIT it out */
        console.log("Document Manager EMIT ", output);
        this.EmitComponentOutput(output);
      }
      else if (!isOutputValid) {
        this.EmitComponentOutput(this.validationOutput);
      }

    })
  }

  validationOutput: ValidationOutput = {
    isInvalid: null,
    errorDOs: []
  };
  validateOutput() {
    //this.commonUtilty.markAllFieldDirty(o); //forms not used in DocMan

    /* Config - Enable/disable exception checks */
    let configMandatory = true; // Requirements with mandatoryFlag MUST have documents
    let configWaivables = true; // Requirements 'waived' must be waivable
    let configWaivedReason = true; // If Requirement is 'waived', reason must be given
    let configDateMandatory = true; // Date mandatory for 'waived' and 'received' requirements
    let configInvestigatorAtleastOneDoc = true; // External User / Investigator must upload at-least one document
    let uploadAtleastOneDocAllStages = false; // Must upload at-least one document, at every stage!

    /* Reset validation output on re-save */
    this.validationOutput = { isInvalid: null, errorDOs: [] };

    let hasErrors: number = 0; // Holds number of errors

    /* MANDATORY FIELDS CHECK */
    let checkMandatory = !this.checkIfAllMandatoryReqsFilled(); //check for errors
    // if (configMandatory && checkMandatory) {
    //   let errorDO = new ErrorDO();
    //   errorDO.errorMsg = "All mandatory documents have not been uploaded";
    //   if (this.stringNames) errorDO.errorMsg += " (" + this.stringNames + ")";
    //   errorDO.componentName = this.getCurrentComponentName();
    //   errorDO.fieldName = "Document Manager";
    //   errorDO.fieldNameDescription = "Documents";
    //   this.validationOutput.isInvalid = true;
    //   this.validationOutput.errorDOs.push(errorDO);
    //   hasErrors++;
    // }
    /* */

    /* All Waived docs are actually Waivable ? */
    let checkWaivedOffsAreWaivable = !this.checkIfWaivedOffWaivable(); //check for errors
    if (configWaivables && checkWaivedOffsAreWaivable) {
      let errorDO = new ErrorDO();
      errorDO.errorMsg = "The following documents are not waivable ";
      if (this.stringNamesWaviedOffWaivable) errorDO.errorMsg += " (" + this.stringNamesWaviedOffWaivable + ")";
      errorDO.componentName = this.getCurrentComponentName();
      errorDO.fieldName = "Document Manager";
      errorDO.fieldNameDescription = "Documents";
      this.validationOutput.isInvalid = true;
      this.validationOutput.errorDOs.push(errorDO);
      hasErrors++;
    }

    /* WAIVED OFF REASON - MANDATORY CHECK */
    let checkWaivedOffReeasonGiven = !this.checkIfWaivedOffReasonGiven(); //check for errors
    if (configWaivedReason && checkWaivedOffReeasonGiven) {
      let errorDO = new ErrorDO();
      errorDO.errorMsg = "All waived off documents must be given a reason and remark ";
      if (this.stringNamesWavied) errorDO.errorMsg += " (" + this.stringNamesWavied + ")";
      errorDO.componentName = this.getCurrentComponentName();
      errorDO.fieldName = "Document Manager";
      errorDO.fieldNameDescription = "Documents";
      this.validationOutput.isInvalid = true;
      this.validationOutput.errorDOs.push(errorDO);
      hasErrors++;
    }

    /* DATE ENTERED FOR REQUIREMENTS THAT ARE WAIVED, RECEIVED ? (Not in 'identified' state) */
    let checkDateEntered = !this.checkIfDateEnteredForNonIdentifiedReqs(); //check for errors
    // if (configDateMandatory && checkDateEntered) {
    //   let errorDO = new ErrorDO();
    //   errorDO.errorMsg = "Date missing for Received/Waived documents: ";
    //   if (this.stringNamesDateMandatory) errorDO.errorMsg += " (" + this.stringNamesDateMandatory + ")";
    //   errorDO.componentName = this.getCurrentComponentName();
    //   errorDO.fieldName = "Document Manager";
    //   errorDO.fieldNameDescription = "Documents";
    //   this.validationOutput.isInvalid = true;
    //   this.validationOutput.errorDOs.push(errorDO);
    //   hasErrors++;
    // }

    /* For EXTERNAL user (Investigator), all 'Public' Requirements must have at-least one document  */
    let checkInvDocs = !this.checkIfAllInvestigatorReqFilled(); //check for errors
    // if (configInvestigatorAtleastOneDoc && checkInvDocs && this.userIsExternal) {
    //   let errorDO = new ErrorDO();
    //   errorDO.errorMsg = "Attach at-least one document for each Requirement and/or mark it as 'Received': ";
    //   if (this.stringNamesInv) errorDO.errorMsg += " (" + this.stringNamesInv + ")";
    //   errorDO.componentName = this.getCurrentComponentName();
    //   errorDO.fieldName = "Document Manager";
    //   errorDO.fieldNameDescription = "Documents";
    //   this.validationOutput.isInvalid = true;
    //   this.validationOutput.errorDOs.push(errorDO);
    //   hasErrors++;
    // }

    /* Upload AT-LEAST one document for a stage */
    if (uploadAtleastOneDocAllStages || this.transactionState === 'claimBranchIntimation' || this.transactionState === 'claimIntimation') {
      let documentDOs = this.extractDocumentDOs();
      let req = this.extractRequirementDOs();
      if ((req && req.length > 0) && (documentDOs && !documentDOs.length)) {
        let errorDO = new ErrorDO();
        errorDO.errorMsg = "Please upload at least one document";
        errorDO.componentName = this.getCurrentComponentName();
        errorDO.fieldName = "Document Manager";
        errorDO.fieldNameDescription = "Documents";
        this.validationOutput.isInvalid = true;
        this.validationOutput.errorDOs.push(errorDO);
        hasErrors++;
      }
    }

    /* Return status */
    return (hasErrors <= 0);

  }


  /* FORCE update document data upon uploading a new file */
  forceUpdateDocData(docData: any) {
    this.isReady = false;
    // Save Requirements
    this.saveRequirements();
    // Save Documents
    let documentDOs = this.extractDocumentDOs();
    // Append newly uploaded file data !!!
    if (docData) {
      let docNew = docData.body; // MUST pass `body` only as it's HTTP request
      documentDOs.push(docNew);
      if(this.mode == 'mini') this.initDocumentData(docData, this.requirements)
    }
    this.apiRequestService.postCallWithAPIMapper('documentSave', documentDOs).subscribe(d => {
      console.log("Document Save response", d);
      // Reload component & emit for other sub-views (Mini views)
      this.docManDataService.dataHasChanged(this.RequirementEntityGuid);
    });
    return;
    /* * /
    if (!this.readonly && this.mode != 'mini' && this.coreComponent) {
      if(!!documentDOs && documentDOs.length){
        this.apiRequestService.postCallWithAPIMapper('documentSave',documentDOs).subscribe(d=>{
          console.log("Document Save response",d);
          // Reload component
          this.docManDataService.dataHasChanged(this.RequirementEntityGuid);
        });
      }
    }
    /* */
  }


  /* Check Mandatory fields */
  stringNames: string = '';
  checkIfAllMandatoryReqsFilled() {
    this.stringNames = '';
    let allFilled = true;
    /* OVERRIDE ---- ERROR CHECKS ARE DONE BY SERVER * /
    return true;
    /* OVERRIDE */
    let allMandatoryReqs = this.documentCollection.filter(d => {
      return (String(d.requirements.mandatoryFl).toUpperCase() == "YES" && !this.isWaived(d.requirements.status))
    });
    allMandatoryReqs.forEach(d => {
      if (d.documents.length == 0) {
        allFilled = false;
        this.stringNames += "'" + this.sanitizeName(d.requirements.requirementCd) + " " + this.sanitizeName(d.requirements.appliesToCd) + "' ";
      }
    });
    return allFilled;
  }

  /* Check Waived off reason */
  stringNamesWavied: string = '';
  checkIfWaivedOffReasonGiven() {
    this.stringNamesWavied = '';
    let allPassed = true;
    let allDCwithWaivedOff = this.documentCollection.filter(d => { return this.isWaived(d.requirements.status) });
    allDCwithWaivedOff.forEach(d => {
      if (!d.requirements.remarks) { //Removed: !d.requirements.waviedOffReasonCd || {ref: Investigation revoke - blocker}
        allPassed = false;
        this.stringNamesWavied += "'" + this.sanitizeName(d.requirements.requirementCd) + " " + this.sanitizeName(d.requirements.appliesToCd) + "' ";
      }
    });
    return allPassed;
  }

  /* Check Waived off is applied only for waivable ones  */
  stringNamesWaviedOffWaivable: string = '';
  checkIfWaivedOffWaivable() {
    this.stringNamesWaviedOffWaivable = '';
    let allPassed = true;
    let allDCwithWaivedOff = this.documentCollection.filter(d => { return this.isWaived(d.requirements.status) });
    allDCwithWaivedOff.forEach(d => {
      let lookupSe = this.lookupRequirements.find(i => i.lookupKey == d.requirements.requirementCd);
      if (lookupSe && (lookupSe.lookupAddValue1 != 1 || lookupSe.lookupAddValue1 != "1")) {
        allPassed = false;
        this.stringNamesWaviedOffWaivable += "'" + this.sanitizeName(d.requirements.requirementCd) + " " + this.sanitizeName(d.requirements.appliesToCd) + "' ";
      }
    });
    return allPassed;
  }

  /* Dates Mandatory Check: Ignore for IDENTIFIED & ORDERED alone */
  stringNamesDateMandatory: string = '';
  checkIfDateEnteredForNonIdentifiedReqs() {
    this.stringNamesDateMandatory = '';
    let allPassed = true;
    let allDCthatAreNotIdentifiedOrOrdered = this.documentCollection.filter(d => { return !(this.isIdentified(d.requirements.status) || this.isOrdered(d.requirements.status)) && !(d.requirements.requirementCd == this.looseDocsKey) && (null !== d.requirements.status) });
    allDCthatAreNotIdentifiedOrOrdered.forEach(d => {
      if (!d.requirements.receivedDt) {
        allPassed = false;
        this.stringNamesDateMandatory += "'" + this.sanitizeName(d.requirements.requirementCd) + "' ";
      }
    });
    return allPassed;
  }

  /* Check Mandatory fields */
  stringNamesInv: string = '';
  checkIfAllInvestigatorReqFilled() {
    this.stringNamesInv = '';
    let allFilled = true;
    let allMandatoryReqs = this.documentCollection.filter(d => { // First, filter Requirements to match our case
      return (d.requirements.visibilityCd == 'EXTERNAL')
    });
    allMandatoryReqs.forEach(d => { // Next, check validity of documents based on above filter
      if (!(this.isReceived(d.requirements.status))) { // || d.documents.length==0
        allFilled = false;
        this.stringNamesInv += "'" + this.sanitizeName(d.requirements.requirementCd) + " " + this.sanitizeName(d.requirements.appliesToCd) + "' ";
      }
    });
    return allFilled;
  }

  //</editor-fold>  Items

  addUploadRowLooseDocs() {
    let documentCollectionObj = {
      'requirements': new RequirementDO(),
      'documents': [],
      'UiFilesList': [],
    };
    documentCollectionObj['requirements'].entityGuid = this.RequirementEntityGuid;
    if (!environment.production && !this.appMetadataHandler.featureFlags.allowEmptyReqEntityGuid) {
      if (!documentCollectionObj['requirements'].entityGuid) {
        console.log('Current Transaction Payload');
        console.log(this.inputDataForEdit);

        throw "EnitityGuid for Requirement added is NULL, Please send valid Input of RequirementEntityGuid to DocumentManagerComponent in" + this.getParentComponentName();
      }
      if (!this.documentCollection) {
        console.log('Current Transaction Payload');
        console.log(this.inputDataForEdit);
        throw `documentCollection Not initialized properly in ${this.getCurrentComponentName()} which is placed in ${this.getParentComponentName()}`
      }
    }

    /* NEW ROW: Loose Docs */
    documentCollectionObj['requirements'].requirementCd = this.looseDocsKey;  //"LOOSE_DOCUMENTS" made an @Input() var
    documentCollectionObj['requirements'].appliesToCd = "SYSTEM";
    documentCollectionObj['requirements'].mandatoryFl = "NO";

    if (!this.documentCollection)
      this.documentCollection = [];
    this.documentCollection.push(documentCollectionObj)
  }


  /* Add */
  addUploadRowCustomReq(reqCd: string, mandatory: false) {
    let documentCollectionObj = {
      'requirements': new RequirementDO(),
      'documents': [],
      'UiFilesList': [],
    };
    /* NEW ROW: Custom Requirement */
    documentCollectionObj['requirements'].entityGuid = this.RequirementEntityGuid;
    documentCollectionObj['requirements'].requirementCd = reqCd;
    documentCollectionObj['requirements'].appliesToCd = "SYSTEM";
    documentCollectionObj['requirements'].mandatoryFl = mandatory ? "YES" : "NO";
    documentCollectionObj['requirements'].clientId = null;
    if (!this.documentCollection)
      this.documentCollection = [];
    this.documentCollection.push(documentCollectionObj)
  }
  removeUploadRow() {
    alert('Cannot remove requirements');
    return false;
  }

  /* Add loose doc row */
  addUploadRowCustomReqLooseDec(reqCd: string, appliesToCd: string, mandatory?: false) {
    if (!reqCd || !appliesToCd) {
      this.msg.error(`Please select a document type`);
      return;
    }
    /* Does this row already exist? */
    if (this.documentCollectionLoose.filter(dc => { return dc.requirements.requirementCd == reqCd && dc.requirements.appliesToCd == appliesToCd }).length) {
      this.msg.error(`'` + this.sanitizeName(appliesToCd) + `' already exists`);
      return;
    }

    let documentCollectionObj = {
      'requirements': new RequirementDO(),
      'documents': [],
      'UiFilesList': [],
    };
    /* NEW ROW: Custom Requirement */
    documentCollectionObj['requirements'].entityGuid = this.RequirementEntityGuid;
    documentCollectionObj['requirements'].requirementCd = reqCd;
    documentCollectionObj['requirements'].appliesToCd = appliesToCd;
    documentCollectionObj['requirements'].mandatoryFl = mandatory ? "YES" : "NO";
    documentCollectionObj['requirements'].clientId = null;
    if (!this.documentCollectionLoose || !this.documentCollectionLoose.length)
      this.documentCollectionLoose = [];
    this.documentCollectionLoose.push(documentCollectionObj)
  }

  /* Get Lookups */
  lookupsToBind = ['documentCd', 'requirementStatusCd', 'docVisibilityCd', 'waivedOffReasonCd', 'requirements', 'userRequirements', 'claimStageCd','policyStageCd','NBURequirementList'];
  lookup$: any = this.commonUtilty.initializeLookupList(this.lookupsToBind);

  /* Local Cache (as we need to use lookups in TS) */
  lookupsLocal: any = [];
  lookupRequirements: any = [];
  lookupUserRequirements: any = [];
  item

  claimIOSub$: any = null;
  guidInstance: string = this.randomString(5);
  userId: string = 'USER';
  userLoggedIn: any = null;
  userLoggedInRoles: Array<any> | null = [];

  ngOnInit() {
    this.subscribeToParentEvent();
    const consoleStyle = 'color: red; padding: 2px 5px; border-radius: 2px';
    if (environment && !environment.production) {
      console.group('%cClaims Basic Details : Usage detected on ' + this.getParentComponentName(), 'color: white; background-color: orange; padding: 2px 5px; border-radius: 2px');
      console.log(`%c<${this.getCurrentComponentName()}></${this.getCurrentComponentName()}>, has been used. `, consoleStyle);
      console.log("%cYou can override default title, message and icon(ng-zorro icon name).", consoleStyle);
      console.log(`%cExample , <${this.getCurrentComponentName()} (componentOutput)='doSomethingOnDataReceived()'></${this.getCurrentComponentName()}>`, consoleStyle);
      console.groupEnd();
    }

    console.log('DocuMan _inputDataForEdit ===============', this._inputDataForEdit);

    if (!this.inputDataForEdit) this.inputDataForEdit = [];

    this.documents = this.inputDataForEdit;
    this.inputDataForEdit = null; // Unset to save mem

    /* Initialize Upload Vars */
    this.initUploadVars();

    /* No requirements ? Get RequirementDO (POLICY INITIALIZATION CASE) */
    if ((Array.isArray(this._requirements) && this._requirements.length == 0) && this.RequirementEntityGuid) {
      let pathVariables = [];
      pathVariables.push(this.RequirementEntityGuid);
      this.apiRequestService.getCallWithAPIMapper('requirementFetchByEntityGuid', null, null, pathVariables).subscribe(data => {
        if (data) {
          this.initDocumentData([], data);
        }
      });
    }

    /* Initialize MAIN onInit() */
    this.initDocumentData(this.documents, this._requirements);

    /* test */
    //this.fetchFile("/usr/local/tomcat/C:/policy-documents/TEST_TETSSUB_null.png");
    console.log(`DOCUMENT_MANAGER_INIT() for ${this.entity} ${this.RequirementEntityGuid} with docs, reqs`, this.documents, this._requirements);

    /* Subscribe to service for data changes */
    this.docManDataService.fetchDataCanges().subscribe((d) => {
      if (d && (d == this.RequirementEntityGuid)) {
        console.log("DATA CHANGE DETECTED from DocumentManagerDataService: ", d);
        // this.initDocumentData(this.documents, this._requirements);
      }
    });

    /* Get lookups for manipulating in TS */
    this.lookupDataService.getLookup('requirements').subscribe(res => {
      this.lookupRequirements = res;
    });
    
    this.apiRequestService.getCallWithAPIMapper('fetchCanUserCreateRequirement',null,null,['NBU']).subscribe(
      {
        next : (res : any[]) => {
          this.lookupUserRequirements = res;
        },
        error : (err : any)=>this.msg.error(err.message),
        complete : ()=>console.log('fetched user requirements lookup',this.lookupUserRequirements)
      }
    )

    /* Subscribe to save/submit */
    if (this.claimIOSub$) this.claimIOSub$.unsubscribe();
    this.claimIOSub$ = this.interactService.claimIOForDocumentManagerSubject$.subscribe(io => {
      if (this.entity !== 'policy') {
        console.log(`Document Manager: claimIOForDocumentManagerSubject$ --> Re-init() REJECTED FOR entity-type ${this.entity}`);
        return;
      }
      else if (!io || (io && !io['requirementDOs'])) {
        console.log("Document Manager: claimIOForDocumentManagerSubject$ --> Subscription does not have valid requirementDOs. Skipping Re-init()");
        return;
      }
      else {
        console.log("Document Manager: claimIOForDocumentManagerSubject$ --> trying re-init() with data", io['requirementDOs']);
        /* Re-init() guid in case of IO input - guid not received from @Input, but coming on save of INT/REG/ADJ/INV  */
        let DOName = this.commonUtilty.getDOName(io)
        let ioRx = io[DOName]
        if (!this.RequirementEntityGuid) {
          this.RequirementEntityGuid = ioRx['guid'];
          console.log("Setting GUID for DM from claimIOForDocumentManagerSubject$", this.RequirementEntityGuid);
        }
        if (ioRx && Array.isArray(ioRx['intimationDt']) && ioRx['intimationDt'].length >= 3) {
          this.setStartDate(ioRx['intimationDt']);
        }
        /* Re-init component */
        let data = [];
        this.io = io;
        console.log("IO IO", this.io);
        if (io) {
          this._requirements = io['requirementDOs'];
          this.ioNominees = this.commonUtilty.extractClientDOListFromIOGeneric(this.io, 'NOMINEE');
        } else {
          this.ioNominees = [];
        }
        this.ioClients = this.io.clientDOs ? this.io.clientDOs : [];
        console.log("IO NOMINEES", this.ioNominees);
        console.log("IO CLIENTS", this.ioClients);
        // this.initDocumentData(data, this._requirements);
      }
    });

    /* Logged-in User's info */
    this.userId = this.userInfoService.getUserId();
    this.userLoggedIn = this.userInfoService.getUserInfo();
    this.userLoggedInRoles = [];
    console.log("Current Logged-in User:", this.userLoggedIn);
    if (this.userLoggedIn && this.userLoggedIn.userRoleDOList) {
      if (this.userLoggedIn.userRoleDOList.length) {
        this.userLoggedInRoles = this.userLoggedIn.userRoleDOList.map(r => r.roleId); // extract roles
      }
    }
    console.log("Current Logged-in User's Roles:", this.userLoggedInRoles);

    /* Check if logged in user is an External User */
    this.externalUsers.forEach(u => {
      if ((this.userLoggedInRoles.indexOf(u) > -1)) {
        this.userIsExternal = true;
      }
    });
    console.log("Current Logged-in User is EXTERNAL USER ", this.userIsExternal);


    // this.documentCollectionMiniMode = [{
    //   requirements: { code: 'DOC1' },
    //   UiFilesList: [],
    //   documents: [{
    //     imageURL: 'test.pdf',
    //     createdUser: 'user1'
    //   }]
    // }];
  } // end ngOnInit()

  transformToNZobj(item) {
    let url = item.imageURL || item.url;
    let filename = this.guessFileName(url);
    return {
      uid: item.id,
      name: filename,
      status: item.status || 'done',
      url: url,
      thumbUrl: item.thumb || 'https://cdn2.iconfinder.com/data/icons/ourea-icons/256/File_-_Default_256x256-32.png'
    }
  }

  private initDocumentData(data, requirements) {
    this.isReady = false;

    /* "NEW" cases */
    if (!this.RequirementEntityGuid) { // || !requirements
      this.isReady = true;
      return;
    }

    if (this.clientRefGuid) this.mode = "mini"; /* if clientRefGuid is passed via @Input(), show mini mode */

    /* Set Document Collection */
    this.documentCollection = [];

    /* Copy Requirements */
    if (requirements) {
      requirements.forEach((req, index) => {
        //delete req.requirementChaserDOs;
        this.documentCollection[index] = {};
        this.documentCollection[index]['requirements'] = req;
        this.documentCollection[index]['documents'] = [];
        this.documentCollection[index]['UiFilesList'] = [];
      });
    }

    /* Additionally, append Loose Documents to the end */
    this.addUploadRowLooseDocs();

    /* Data exists? SET it -- Reserved for Future use */
    if (data && this.commonUtilty.isArrayIterable(data) && data.length) {
      data.forEach(doc=>{
        if(doc && doc.documentTypeCd == 'Proposal Document' && doc.imageURL) this.viewDocumentInSplitMode(doc.imageURL)
      })
    }

    /* Get all documents of this Entity using its `guid` */
    let guid = this.RequirementEntityGuid;
    let pathVariables = [];
    pathVariables.push(guid || null);

    this.apiRequestService.getCallWithAPIMapper('documentFetchByEntityGuid', null, null, pathVariables).subscribe(data => {
    // this.apiRequestService.getCallWithAPIMapper(`documentFetchByEntityGuid/${guid}`).subscribe(data => {
      this.documentsFromServerMini = JSON.parse(JSON.stringify(data));
      this.documentsFromServer = data;
      this.documents = data;
      /* All documents from server */
      if (this.documentsFromServer.length) {

        this.documentCollection.forEach((d, index) => {
          // Set default visibility for Requirement Visibility
          if (!d.requirements.visibilityCd) d.requirements.visibilityCd = this.defaultVisibilityCd;

          let category = d.requirements.requirementCd;
          let clientGuid = d.requirements.clientRefGuid;
          d.documents = this.documentsFromServer.filter(i => i.documentTypeCd == category && i.clientRefGuid == clientGuid); //CHANGE LOGIC HERE
          // Remove used docs from main list (filter !=) to keep only loose_docs in the end
          this.documentsFromServer = this.documentsFromServer.filter(i => !(i.documentTypeCd == category && i.clientRefGuid == clientGuid)); //CHANGE LOGIC HERE

          /* Set date */
          if (d.requirements.receivedDt) {
            this.dateArray[index] = new Date(d.requirements.receivedDt);
          }
          else this.dateArray[index] = null;

        });

        /* Sort by Document's ID (server returns reverse order!; so that wont work for us as we use doc[0] for saving meta data) */
        this.documentCollection.forEach((d, index) => {
          if (d.documents.length) {
            d.documents.sort(this.dynamicSort('id'));
          }
        });


        /* Put all unassigned docs in LOOSE_DOCS */
        let indexLooseDocs = this.documentCollection.length - 1;
        this.documentCollection[indexLooseDocs].documents.push(...this.documentsFromServer);

        /* Transform all LOOSE_DOCS for custom multi-level view */
        this.documentCollectionLoose = [];
        /* we are creating fake 'requirements' for loose doc categories (UI purposes alone) */
        let looseDocReqs = this.documentCollection[indexLooseDocs].requirements;
        let allLooseDocs = this.documentCollection[indexLooseDocs].documents || [];

        allLooseDocs.forEach((doc, index) => {

          let category = doc.documentTypeCd;
          let subCategory = doc.documentSubTypeCd;

          /* If already processed, continue */
          if (this.documentCollectionLoose.filter(dc => { return dc.requirements.requirementCd == category && dc.requirements.appliesToCd == subCategory }).length) {
            //CHANGE LOGIC HERE (loose document hierarchy filter)
          }
          else {
            /* Create a new fake requirement w/ its document set */
            /* NEW Requirement (User for UI alone) */
            let documentCollectionObj = {
              'requirements': new RequirementDO(),
              'documents': [],
              'UiFilesList': [],
            };
            documentCollectionObj['requirements'].entityGuid = this.RequirementEntityGuid;
            documentCollectionObj['requirements'].requirementCd = category;
            documentCollectionObj['requirements'].appliesToCd = subCategory;
            documentCollectionObj['requirements'].mandatoryFl = "NO";
            documentCollectionObj['requirements'].clientId = null;
            /* Add the documents */
            let docs = allLooseDocs.filter(i => { return i.documentTypeCd == category && i.documentSubTypeCd == subCategory }); //CHANGE LOGIC HERE (loose document hierarchy filter)
            // Remove used docs from main list (filter !=)
            //allLooseDocs = allLooseDocs.filter(i=>{return i.documentTypeCd!==category && i.documentSubTypeCd!==subCategory}); //CHANGE LOGIC HERE (loose document hierarchy filter)
            documentCollectionObj['documents'] = docs;
            this.documentCollectionLoose.push(documentCollectionObj);
          }

          /* Sort by Document's ID (server returns reverse order!; so that wont work for us as we use doc[0] for saving meta data) */
          this.documentCollectionLoose.forEach((d, index) => {
            if (d.documents.length) {
              /* Sort */
              d.documents.sort(this.dynamicSort('id'));
              /* Set date for loose docs */
              if (d.documents[0].documentRecievedDt) {
                this.dateArrayLoose[index] = new Date(d.documents[0].documentRecievedDt);
              }
              else this.dateArrayLoose[index] = null;
            }
            else {
              this.dateArrayLoose[index] = null;
            }
          });

        });


        /* Take out all private docs for EXTERNAL USERS */
        if (this.userIsExternal || this.visibility == 'public-only') {
          /* Filter out all documents that are not public */
          /* NOTE: CSS-based disable done as of now; reason: whole array needs to be sent back to server for changes */
        }


        /* Transform and Set * /
        for( let i=0; i<this.documentsFromServer.length; i++ ) {
          //this.documentCollection[0]['UiFilesList'].push(this.transformToNZobj(this.documentsFromServer[i]));
          this.documentCollection[0]['documents'].push(this.documentsFromServer[i]);
        }
        /* */

      }

      /* Set meta and process dates for missing ones */
      this.documentCollection.forEach((d, index) => {
        // Set default visibility for Requirement Visibility
        if (!d.requirements.visibilityCd) d.requirements.visibilityCd = this.defaultVisibilityCd;
        /* Set date */
        if (d.requirements.receivedDt) {
          this.dateArray[index] = new Date(d.requirements.receivedDt);
        }
        else this.dateArray[index] = null;
      });

      /* Init Mini View */
      this.initMiniView();

      /* Enable UI display */
      setTimeout(() => {
        this.isReady = true;
        /* Init Mini View */
        this.initMiniView();
      }, 512);

    });

  }

  extractRequirementDOs() {
    let requirementDOs = [];
    if (this.documentCollection && this.documentCollection.length > 0)
      this.documentCollection.forEach(document => {
        if (document['requirements'].requirementCd !== this.looseDocsKey) requirementDOs.push(document['requirements']);
      });
    return requirementDOs;
  }

  extractDocumentDOs() {
    /* Fetches the freshest docs list to emit */
    let docDOAll = [];
    let docDOLoose = [];
    if (this.documentCollection && this.documentCollection.length > 0)
      this.documentCollection.forEach(document => {
        if (document['documents'].length) docDOAll.push(...document['documents']);
      });
    if (this.documentCollectionLoose && this.documentCollectionLoose.length > 0)
      this.documentCollectionLoose.forEach(document => {
        if (document['documents'].length) docDOLoose.push(...document['documents']);
      });
    /* no need to merge, as it is by reference */
    let documentDO = docDOAll;
    return documentDO;
  }

  ngOnDestroy(): void {
    console.log("DocumentManagerComponent ngOnDestroy() DESTROYED!!!");
  }

  /* File Operations */
  fileListTemp: NzUploadFile[] = [];
  uploading: boolean = false;
  fileUploadEndpoint: string;
  fileFetchEndpointRAW: string;
  fileFetchEndpoint: string;

  /* Tab Index */
  tabIndex: number = 0;

  initUploadVars() {
    /* API Endpoints */
    this.fileUploadEndpoint = this.appConfig.baseApiPath + 'master-service/document/saveMultipart';
    this.fileFetchEndpointRAW = 'master-service/document/fetchMultipart';
    this.fileFetchEndpoint = this.appConfig.baseApiPath + this.fileFetchEndpointRAW;
    /* Set loose_docs key */
    switch (this.entity) {
      case 'policy': this.looseDocsKey = "POLICY_DOCUMENTS"; break;
      case 'claim': this.looseDocsKey = "CLAIM_DOCUMENTS"; break;
      default: this.looseDocsKey = "LOOSE_DOCUMENTS"; break;
    }
  }

  fileUploadBefore = (file: NzUploadFile, fileList): boolean => {
    this.preUploadImgChecks(file).subscribe(
      n => {
        if (n) { //n = true => All passed
          this.fileListTemp = []; //reset
          this.fileListTemp.push(file); //push
          this.fileUpload(); // handle upload & reset component
          return true;
        }
      },
      e => { return false },
      () => { return false }
    );
    return false; // We need to return false to nz-upload (else it will invoke onError())
  };
  fileRemove = (file: NzUploadFile): boolean => {
    alert('Cannot remove uploaded file. Please upload new file to replace');
    return false;
  };

  /* Image Upload checks */
  preUploadImgChecks = (file: NzUploadFile) => {
    return new Observable((observer: Observer<boolean>) => {
      /* Bypass checks * /
      observer.next(true);
      observer.complete();
      return;
      /* */
      /* Max File Size */
      // const maxFileSize = 5; /* in MB */
      const maxFileSize = 30; /* in MB */

      /* Supported file types */
      let fileName = file.name;
      let fileType = file.type;

      let isSupportedFileType =
        file.type.includes('image') ||
        file.type.includes('video') ||
        file.type.includes('audio') ||
        file.type.includes('pdf');

      /* New check for 'supported file' upload [overrides previous check] */
      if (this.guessFileType(fileName) !== "File") isSupportedFileType = true;

      console.log("File Name, File type: ", fileName, " ----- ", fileType);

      if (!isSupportedFileType) {
        this.msg.error(`Unsupported file type. Please select a Document, Image, Video or Audio file`);
        observer.complete();
        this.initDocumentData(this.documents, this._requirements); //reset
        return;
      }
      const fileSizeOK = file.size / 1024 / 1024 < maxFileSize;
      if (!fileSizeOK) {
        this.msg.error(`Document must smaller than ${maxFileSize} MB`);
        observer.complete();
        this.initDocumentData(this.documents, this._requirements); //reset
        return;
      }
      observer.next(isSupportedFileType && fileSizeOK);
      observer.complete();
      return;
    });
  };


  sel_documentTypeCd: any = '';
  sel_documentSubTypeCd: any = '';
  sel_visibilityCd: any = '';
  sel_clientRefGuid: any = '';
  /* setUploadParams() is required because there no way to set/pass dynamic values to nzBeforeUpload */
  setUploadParams(req, tabIndex: number = 0, clientRef: any = false) {
    this.sel_documentTypeCd = req.requirementCd;
    this.sel_documentSubTypeCd = req.appliesToCd;
    this.sel_clientRefGuid = clientRef ? clientRef : req.clientRefGuid;
    this.sel_visibilityCd = req.visibilityCd || this.defaultVisibilityCd; // Set default visibility
    if (this.userIsExternal) this.sel_visibilityCd = this.defaultVisibilityCdExternalUser; // Force change visibility for external users to PUBLIC
    this.tabIndex = tabIndex;
  }

  /* Core function that handles upload */

  headers: HttpHeaders = new HttpHeaders({
    'Authorization': this.apiRequestService.token,
    'applicationId': environment.applicationId,
    'hash': '7h1nk[)j',
  });

  /* Handles the uploading of file */
  verificationMap = {};
  fileUpload(): void {
    const url = this.fileUploadEndpoint;
    const formData = new FormData();
    this.uploading = true;
    this.isReady = false; // loading ...
    this.msg.loading('Uploading document', { nzDuration: 1000 });
    // Set Data & Defaults for the Uploaded file
    let lastFilename = '', lastFiletype = '';
    this.fileListTemp.forEach((file: any) => { lastFilename = file.name; lastFiletype = file.type; });
    const obj = {
      entityGuid: this.RequirementEntityGuid,
      documentTypeCd: this.sel_documentTypeCd,
      documentSubTypeCd: this.sel_documentSubTypeCd,
      guid: this.randomString(10),
      entityImageName: lastFilename, entityImageMimeType: lastFiletype,
      clientRefGuid: this.clientRefGuid ? this.clientRefGuid : this.sel_clientRefGuid ? this.sel_clientRefGuid : null,
      visibilityCd: this.userIsExternal ? this.defaultVisibilityCdExternalUser : this.defaultVisibilityCd, // this.sel_visibilityCd, // Set default PRIVATE status to newly uploaded file
      // subTxEntityGuid: this.collaborationGuid ? this.collaborationGuid : null,

    };
    console.log("Doc Save POST Object");
    console.table(obj);
    const options = {
      reportProgress: true,
      headers: this.headers,
    };
    formData.append('json', JSON.stringify(obj));
    // Attach File(s) [1 in this case]
    this.fileListTemp.forEach((file: any) => {
      formData.append('file', file);
    });
    const req = new HttpRequest('POST', url, formData, options);
    this.http
      .request(req)
      .pipe(filter(e => e instanceof HttpResponse))
      .subscribe(
        (e: {}) => {
          this.uploading = false;
          this.msg.success('Upload successful');
          if (this.appMetadataHandler.featureFlags.enableOCRVerificationInDocumentManager) {
            this.msg.loading('Verifying Document', { nzDuration: 5000 })
            this.verifyDocumentWithOCR(e['body'].imageURL, 'preview').subscribe(base64Str => {
              this.documentValidatorService.validateDocument(base64Str, e['body'].documentCd).subscribe(docValidityOutput => {
                // e['body'].dataVerified = true
                // e['body'].statusVerified = true
                e['body']['isDocumentValid'] = docValidityOutput.status['finalStatus'];
                this.msg.success('Document verified')
                this.verificationMap[e['body']['guid']] = { docValidityOutput }
              })
            })
          }
          // this.initDocumentData(this.documents, this._requirements); // Re-initialize doc data
          /// EDITED
          // this.docManDataService.dataHasChanged(this.RequirementEntityGuid); // Use this
          this.forceUpdateDocData(e); // this calls dataHasChaged
          this.fileListTemp = [];
          if(this.mode == 'mini'){
            this.EmitComponentOutput(e);
          }
        }, (e) => {
          this.uploading = false;
          this.initDocumentData(this.documents, this._requirements); // Re-initialize doc data
          this.msg.error('Upload failed');
          if(this.mode == 'mini'){
            this.EmitComponentOutput(e);
          }
        }
      );
  }

  modalFilePreview: boolean = false;
  previewDataStream: any = null;
  previewDataStreamUnsanitized: string = '';
  previewFileUrl: string = '';
  fileIsBeingDownloaded: boolean = false;

  /* Retrieve file, perform actions on data  */
  fetchFile1(url, action: string = 'return'): void | boolean | any {

    // Basic checks and resets
    this.previewDataStream = null;
    this.previewFileUrl = url;
    if (!url) return false;

    let body = { "imageURL": url };
    let guessedFilename = this.guessOriginalFileNameFromImgURL(url);

    /* No need to fetch file if file is not previewable */
    if ('preview' == action && !this.fileIsPreviewable(url)) {
      this.previewDataStream = null;
      this.modalFilePreview = true; //open the modal anyway, and show "download"
      return false;
    }

    this.modalFilePreview = ('preview' == action);

    this.fileIsBeingDownloaded = true;

    /* Get file contents (bin) */
    this.http.post<Blob>(this.fileFetchEndpoint, body, {
      headers: this.headers,
      responseType: 'blob' as 'json'
    })
      .pipe(map(res => {
        if (!res) { console.log(" ----- EMPTY FILE RESPONSE ----- "); return; }
        switch (action) {
          case 'download':
            this.fileIsBeingDownloaded = false;
            this.downloadFile(res, guessedFilename);
            break;
          case 'return':
            this.fileIsBeingDownloaded = false;
            return res;
          case 'preview':
            let me = this;
            /* Special Case Handling: TIFF, TIF using JS decoder */
            if (['tif', 'tiff'].includes(this.guessFileExtension(guessedFilename))) {
              let reader = new FileReader();
              reader.readAsArrayBuffer(res);
              reader.onloadend = function () {
                let tiff = new Tiff({ buffer: reader.result }); // parse, decode
                let canvas = tiff.toCanvas(); // convert decoded image to HTML canvas
                setTimeout(() => {
                  let querySelectorElement = '#tiff-canvas';
                  let nodeList = document.getElementById(querySelectorElement);
                  if (nodeList && nodeList.childNodes[0]) nodeList.removeChild(nodeList.childNodes[0]
                    && document && document.querySelector(querySelectorElement) && canvas);
                  document.querySelector(querySelectorElement).appendChild(canvas);
                }, 500);
                me.previewDataStream = '  ';
                me.fileIsBeingDownloaded = false;
                me.modalFilePreview = true;
                return;
              };
              return;
            }
            let base64data;
            let reader = new FileReader();
            reader.readAsDataURL(res);
            reader.onloadend = function () {
              base64data = reader.result;
              base64data = base64data.split(',')[1];
              /* Decide Charset/Encoding */
              let charsetEncoding = 'data:image/jpeg;base64';
              switch (me.guessFileType(url)) {
                case 'Image':
                  charsetEncoding = 'data:image/jpeg;base64';
                  break;
                case 'Video':
                  charsetEncoding = 'data:video/mp4;base64';
                  break;
                case 'Audio':
                  charsetEncoding = 'data:audio/ogg;base64';
                  break;
                case 'Document':
                  charsetEncoding = 'data:application/' + me.guessFileExtension(url) + ';base64';
                  break;
                case 'Html':
                  charsetEncoding = 'data:text/html;base64';
                  break;
              }
              if ('pdf' == me.guessFileExtension(url))
                me.previewDataStream = me.base64ToArrayBuffer(base64data); //charsetEncoding + "," + base64data;
              else if ('html' == me.guessFileExtension(url)) {
                let url = decodeURIComponent(escape(window.atob(base64data)));
                me.previewDataStream = me.sanitizer.bypassSecurityTrustHtml(url);
              }
              else
                me.previewDataStream = me.sanitizer.bypassSecurityTrustUrl(charsetEncoding + "," + base64data);
              me.previewDataStreamUnsanitized = charsetEncoding + "," + base64data;
              //me.previewDataStream = me.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(res));
              me.fileIsBeingDownloaded = false;
              me.modalFilePreview = true;
            };
            break;
        }
      }))
      .subscribe(d => { }, e => { console.log("Document Fetch http err", e) });
  }

  fetchFile(url, action: string = 'return'): void | boolean | any {
  this.previewDataStream = null;
  this.previewFileUrl = url;
  if (!url) return false;

  const body = { imageURL: url };
  const guessedFilename = this.guessOriginalFileNameFromImgURL(url);

  if (action === 'preview' && !this.fileIsPreviewable(url)) {
    this.previewDataStream = null;
    this.modalFilePreview = true;
    return false;
  }

  this.modalFilePreview = (action === 'preview');
  this.fileIsBeingDownloaded = true;

 this.http.post(this.fileFetchEndpoint, body, {
  headers: this.headers,
  responseType: 'blob' // ✅ correct way
})
    .pipe(
      map(res => {
        if (!res) {
          console.log(" ----- EMPTY FILE RESPONSE ----- ");
          return;
        }

        console.log('Blob type:', res.type);
      console.log('Blob size:', res.size);

        switch (action) {
          case 'download':
            this.fileIsBeingDownloaded = false;
            this.downloadFile(res, guessedFilename);
            break;

          case 'return':
            this.fileIsBeingDownloaded = false;
            return res;

          case 'preview':
            const ext = this.guessFileExtension(guessedFilename).toLowerCase();

            if (['tif', 'tiff'].includes(ext)) {
              const reader = new FileReader();
              reader.readAsArrayBuffer(res);
              reader.onloadend = () => {
                const tiff = new Tiff({ buffer: reader.result });
                const canvas = tiff.toCanvas();
                setTimeout(() => {
                  const target = document.getElementById('tiff-canvas');
                  if (target?.firstChild) target.removeChild(target.firstChild);
                  target?.appendChild(canvas);
                }, 500);
                this.previewDataStream = ' ';
                this.fileIsBeingDownloaded = false;
                this.modalFilePreview = true;
              };
              return;
            }

            // if (ext === 'pdf') {
            //   const objectUrl = URL.createObjectURL(res);
            //   // this.previewDataStream = this.sanitizer.bypassSecurityTrustResourceUrl(objectUrl);
            //   this.previewDataStream = objectUrl;
            //   this.previewDataStreamUnsanitized = objectUrl;
            //   this.fileIsBeingDownloaded = false;
            //   this.modalFilePreview = true;
            //   return;
            // }

            if (ext === 'pdf') {
              // Force the correct MIME type
              const pdfBlob = new Blob([res], { type: 'application/pdf' });
              const objectUrl = URL.createObjectURL(pdfBlob);
              this.previewDataStream = objectUrl;
              this.previewDataStreamUnsanitized = objectUrl;
              this.fileIsBeingDownloaded = false;
              this.modalFilePreview = true;
              return;
            }

            const reader = new FileReader();
            reader.readAsDataURL(res);
            reader.onloadend = () => {
              let base64data = reader.result as string;
              base64data = base64data.split(',')[1];

              let charsetEncoding = 'data:image/jpeg;base64';
              switch (this.guessFileType(url)) {
                case 'Image': charsetEncoding = 'data:image/jpeg;base64'; break;
                case 'Video': charsetEncoding = 'data:video/mp4;base64'; break;
                case 'Audio': charsetEncoding = 'data:audio/ogg;base64'; break;
                case 'Document': charsetEncoding = 'data:application/' + ext + ';base64'; break;
                case 'Html': charsetEncoding = 'data:text/html;base64'; break;
              }

              if (ext === 'html') {
                const decoded = decodeURIComponent(escape(window.atob(base64data)));
                this.previewDataStream = this.sanitizer.bypassSecurityTrustHtml(decoded);
              } else {
                this.previewDataStream = this.sanitizer.bypassSecurityTrustUrl(`${charsetEncoding},${base64data}`);
              }

              this.previewDataStreamUnsanitized = `${charsetEncoding},${base64data}`;
              this.fileIsBeingDownloaded = false;
              this.modalFilePreview = true;
            };
            break;
        }
      })
    )
    .subscribe({
      error: err => console.log("Document Fetch http err", err)
    });
}



  @Input() isOCRDocument: boolean = false;
  previewDocumentDO: any;
  previewRequirementDO: any;

  documentDetectionMsg = null;
  documentDetectionSuccess = false;
  documentDetectionResponse: any;
  detectDocument(base64) {
    const headers = { 'Content-Type': 'application/json' };
    let request = {
      "product_type": "FWARISKANALYSIS",
      "business_process": "AIOCR",
      "module_name": "OCR",
      "file":base64
  }
    // let URL = `https://product-fwa.metamorphosys.co.in/dev-fwa-generic/ocr/document_classification`
    let URL = `https://${this.appConfig.serverHost}/dev-fwa-generic/ocr/document_classification`
  // this.documentDetectionSuccess = true;
    this.http.post<any>(URL, request, { headers })
      .subscribe(jsonResp => {
        if (jsonResp) {
          // this.isDocumentDetectionInProgress = false;
          this.documentDetectionSuccess = true;
          this.documentDetectionResponse = jsonResp;
          this.msg.remove(this.documentDetectionMsg);
          // this.msg.success("Document detection is successful", {nzDuration: 2000});
          console.log("file detect response", jsonResp)
        }
      });

  }

  base64ToBinary(base64: string) {
     // Convert base64 to binary
     const binaryString = window.atob(base64);
     const bytes = new Uint8Array(binaryString.length);
     for (let i = 0; i < binaryString.length; i++) {
       bytes[i] = binaryString.charCodeAt(i);
     }
     return bytes.buffer;
  }

  /* Retrieve file, perform actions on data  */
  verifyDocumentWithOCR(url, action: string = 'return', splitMode?): void | boolean | any {
    let base64StrSubject: Subject<any> = new Subject();
    // Basic checks and resets
    this.previewDataStream = null;
    this.previewFileUrl = url;
    if (!url) return false;

    let body = { "imageURL": url };
    let guessedFilename = this.guessFileName(url);

    /* No need to fetch file if file is not previewable */
    if ('preview' == action && !this.fileIsPreviewable(url)) {
      this.previewDataStream = null;
      this.modalFilePreview = false; //open the modal anyway, and show "download"
      return false;
    }

    // this.modalFilePreview = ('preview' == action);

    this.fileIsBeingDownloaded = true;

    /* Get file contents (bin) */
    this.http.post<Blob>(this.fileFetchEndpoint, body, {
      headers: this.headers,
      responseType: 'blob' as 'json'
    })
      .pipe(map(res => {
        switch (action) {
          case 'return':
            this.fileIsBeingDownloaded = false;
            return res;
            case 'preview':
            let me = this;
            /* Special Case Handling: TIFF, TIF using JS decoder */
            if (['tif', 'tiff'].includes(this.guessFileExtension(guessedFilename))) {
              // if (this.appMetadataHandler.featureFlags.legacyTiffPreview) {
                // legacy tiff-reader script which used outdated version of jQuery
                let reader = new FileReader();
                reader.readAsArrayBuffer(res);
                reader.onloadend = function () {
                  let tiff = new Tiff({ buffer: reader.result }); // parse, decode
                  //let canvas = tiff.toCanvas(); // convert decoded image to HTML canvas
                  setTimeout(() => {
                    let querySelectorElement = '#tiff-canvas';
                    let nodeList = document.getElementById(querySelectorElement);
                    if (nodeList && nodeList.childNodes[0]) nodeList.removeChild(nodeList.childNodes[0]);
                    /*Checking the no of images in tiff file and appending*/
                    for (var i = 0, len = tiff.countDirectory(); i < len; ++i) {
                      tiff.setDirectory(i);
                      var canvas = tiff.toCanvas();
                      if(document && document.querySelector(querySelectorElement) && canvas){
                        document.querySelector(querySelectorElement).appendChild(canvas);
                      }
                    }
                  }, 500);
                  me.previewDataStream = '';
                  me.fileIsBeingDownloaded = false;
                  me.modalFilePreview = false;
                  return;
                }
                return;
              // }
              break;
            }  

            let base64data;
            let reader = new FileReader();
            reader.readAsDataURL(res);
            reader.onloadend = function () {
              base64data = reader.result;
              base64data = base64data.split(',')[1];
              let charsetEncoding = 'data:image/jpeg;base64';
              switch (me.guessFileType(url)) {
                case 'Image':
                  charsetEncoding = 'data:image/jpeg;base64';
                  break;
                case 'Video':
                  charsetEncoding = 'data:video/mp4;base64';
                  break;
                case 'Audio':
                  charsetEncoding = 'data:audio/ogg;base64';
                  break;
                case 'Document':
                  charsetEncoding = 'data:application/' + me.guessFileExtension(url) + ';base64';
                  break;
                case 'Html':
                  charsetEncoding = 'data:text/html;base64';
                  break;
              }
              me.previewDataStream = me.sanitizer.bypassSecurityTrustUrl(charsetEncoding + "," + base64data);
              me.previewDataStreamUnsanitized = charsetEncoding + "," + base64data;
              //me.previewDataStream = me.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(res));
              me.fileIsBeingDownloaded = false;
              me.modalFilePreview = false;
              if(!splitMode) base64StrSubject.next(me.previewDataStreamUnsanitized);
              else {
                // me.dataTransformService.isSidebarCollapsed = true;
                let splitModeObj = { imgBase64 : me.previewDataStreamUnsanitized, closeDrawer: true}
                me.dataTransformService.docuPanelOpen = false;
                me.interactService.viewDocumentInSplitMode(splitModeObj);
              }
              /* Decide Charset/Encoding */
            };
        }
      }))
      .subscribe(d => { }, e => { console.log("Document Fetch http err", e) });
      if(!splitMode) return base64StrSubject;
  }

  /* =========== File name Helpers (guessers) =========== */
  /* @thinkdj 30 July 2019 */
  guessFileName(url) {
    if (!url) { return ''; }
    const character = (url.indexOf('\\') > -1) ? '\\' : '/';
    return url.substring(url.lastIndexOf(character) + 1);
  }
  guessFileExtension(url) {
    const filename = this.guessFileName(url);
    return String(filename.substring(filename.lastIndexOf('.') + 1)).toLowerCase();
  }
  guessOriginalFileName(fileObj) {
    if (typeof fileObj !== 'object') { return ''; }
    return (fileObj.entityImageName) ? fileObj.entityImageName : this.guessFileName(fileObj.imageURL);
  }
  guessOriginalFileNameFromImgURL(imgUrl) {
    if (!this.documentsFromServerMini || !this.documentsFromServerMini.length) return '';
    const fileObj = this.documentsFromServerMini.find(d => d.imageURL === imgUrl); /* unfiltered copy of documentsFromServer */
    if (typeof fileObj === 'object') { return this.guessOriginalFileName(fileObj); }
    return '';
  }

  /* Guess filetype IF extension is not found in file URL (Eg: filenet case) */
  guessFileExtensionFromMIME(url) {
    // (1) Take from entityImageMimeType (2) Split `/` (3) Return extension
  }

  /* Generic function to guess file type */
  /* NOW ALSO USED as for finding 'supported files' *** */
  guessFileType(url): string {
    let extension = url;
    if (url && url.length > 4) extension = this.guessFileExtension(url);
    /* Find file type */
    if (['jpg', 'png', 'x-png', 'jpeg', 'pjpeg', 'jfif', 'gif', 'tiff', 'tif', 'bmp', 'webp'].includes(extension)) return "Image";
    else if (['pdf', 'doc', 'docx'].includes(extension)) return "Document";
    else if (['mp4', 'mov', 'avi', 'mpeg', 'webm'].includes(extension)) return "Video";
    else if (['mp3', 'wav', 'ogg'].includes(extension)) return "Audio";
    else if (['xls', 'xlsx', 'xlt', 'xltx', 'xlsm', 'xlsb', 'xla', 'xlam', 'xltm'].includes(extension)) return "Sheet";
    else if (['zip', 'gz', 'rar', 'rar5'].includes(extension)) return "Archive";
    else if (['eml', 'msg'].includes(extension)) return "Email";
    else if (['html', 'htm'].includes(extension)) return "HTML";
    return "File"; // un-supported
  }
  fileIsPreviewable(url): boolean {
    let supportedFormats = [ // Add all supported formats here
      'jpg', 'png', 'jpeg', 'jfif', 'gif', 'bmp', 'webp', //Images
      'tif', 'tiff', // TIFF images (requires decoder plugin)
      'mp4', 'mov', 'avi', 'mpeg', 'webm', // Videos
      'mp3', 'wav', 'ogg', //Audio
      'pdf', // PDF Doc
      'html', 'htm', // HTML Files
    ];
    let extension = this.guessFileExtension(url);
    return supportedFormats.includes(extension);
  }

  /* Emulate a download-file click */
  downloadFile(blob: any, filename: string): boolean {
    if (!filename) filename = 'file.jpg';
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.setAttribute('style', 'display:none;');
    document.body.appendChild(a);
    a.href = url;
    a.download = filename;
    a.click();
    return true;//url;
  }

  handleError(e) { console.log(e) };

  /* Sanitize */
  sanitizeName(string, append: any = false, refGuid: any = false, referneceNum?: any): string {
    if (string) {
      //string = "ID_PROOF_NOMINEE";
      /* Check if lookup exists for key */
      let lookupSe = this.lookupRequirements.find(i => i.lookupKey == string);
      //console.log("LOOK",string,lookupSe);
      if (lookupSe) {
        string = lookupSe.lookupValue;
        //console.log("--- using ",string);
      }
      /* Continue with sanitization */
      string = String(string);
      string = string.replace("_", " ");
      if (string.includes("_")) string = string.replace("_", " ");
      if (!lookupSe) string = this.capitalizeWords(string);
      string = this.autoCapitalize(string);
    }
    if (append) {
      string = string + " (" + append + ")";
    }
    if (refGuid && this.clientDOHM) {
      let clientDO = this.clientDOHM.get(refGuid);
      if(clientDO){
        string = string + " - " + this.capitalizeWords(String(clientDO['name']));
      }
    }
    if (referneceNum) {
      string = string + " (" + referneceNum + ")";
    }
    return string;
  }
  
  capitalizeWords = function (str: string) {
    str = str.toLowerCase();
    return str.replace(/(?:^|\s)\S/g, function (a) { return a.toUpperCase(); });
  };
  autoCapitalize = function (str) {
    let arr = str.split(" ");
    for (let i = 0; i < arr.length; i++) {
      if (arr[i].length < 3) arr[i] = arr[i].toUpperCase();
      /* Undo some known words */
      if (['OF', 'BY', 'THE'].includes(arr[i])) arr[i] = arr[i].toLowerCase();
    }
    return arr.join(" ");
  };
  strSpecialCases = function (str) {
    if (str == "CLAIM DOCUMENTS") str = "Claim Documents";
    if (str == "POLICY DOCUMENTS") str = "Policy Documents";
    let arr = str.split(" ");
    for (let i = 0; i < arr.length; i++) {
      if (['id'].includes(arr[i].toLowerCase())) arr[i] = arr[i].toUpperCase();
    }
    return arr.join(" ");
  };

  randomString(len, charSet?) {
    charSet = charSet || 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    var randomString = '';
    for (var i = 0; i < len; i++) {
      var randomPoz = Math.floor(Math.random() * charSet.length);
      randomString += charSet.substring(randomPoz, randomPoz + 1);
    }
    return randomString;
  }

  /* Custom XHR Requests (UNUSED) * /
  customXHRReq = (item: UploadXHRArgs) => {
    const formData = new FormData();
    // tslint:disable-next-line:no-any
    formData.append('file', item.file as any);
    formData.append('id', '1000');
    const req = new HttpRequest('POST', item.action, formData, {
      reportProgress: true,
      withCredentials: true
    });
    // `Subscription` to nz-upload
    return this.http.request(req).subscribe((event: HttpEvent<{}>) => {
      if (event.type === HttpEventType.UploadProgress) {
        if (event.total > 0) {
          // tslint:disable-next-line:no-any
          (event as any).percent = event.loaded / event.total * 100;
        }
        item.onProgress(event, item.file);
      } else if (event instanceof HttpResponse) {
        item.onSuccess(event.body, item.file, event);
      }
    }, (err) => {
      // item.onError(err, item.file);
      console.log(err);
    });
  };
  customHugeXHRReq = (item: UploadXHRArgs) => {
    const size = item.file.size;
    const chunkSize = parseInt((size / 3) + '', 10);
    const maxChunk = Math.ceil(size / chunkSize);
    const reqs = Array(maxChunk).fill(0).map((v: {}, index: number) => {
      const start = index * chunkSize;
      let end = start + chunkSize;
      if (size - end < 0) {
        end = size;
      }
      const formData = new FormData();
      formData.append('file', item.file.slice(start, end));
      formData.append('start', start.toString());
      formData.append('end', end.toString());
      formData.append('index', index.toString());
      const req = new HttpRequest('POST', item.action, formData, {
        withCredentials: true
      });
      return this.http.request(req);
    });
    return forkJoin(...reqs).subscribe(resules => {
      item.onSuccess({}, item.file, event);
    }, (err) => {
      item.onError(err, item.file);
    });
  };
  /* */

  // Lookups
  // lookupsToBind = ['documentTypeCd','documentSubTypeCd'];
  // lookup$ = this.commonUtilty.initializeLookupList(this.lookupsToBind)



  /* ================== DATA FORMATS INTERCHANGE ================== */
  base64ToArrayBuffer(base64) {
    var binary_string = window.atob(base64);
    var len = binary_string.length;
    var bytes = new Uint8Array(len);
    for (var i = 0; i < len; i++) {
      bytes[i] = binary_string.charCodeAt(i);
    }
    return bytes.buffer;
  }
  //var uintArray = Base64Binary.decode(base64_string);
  //var byteArray = Base64Binary.decodeArrayBuffer(base64_string);
  //**blob to dataURL**
  blobToDataURL(blob, callback) {
    var a = new FileReader();
    //a.onload = function(e) {callback(e.target.result);}
    a.readAsDataURL(blob);
  }
  blobToBase64 = function (blob, callback) {
    var reader = new FileReader();
    reader.onload = function () {
      var dataUrl = String(reader.result);
      var base64 = dataUrl.split(',')[1];
      callback(base64);
    };
    reader.readAsDataURL(blob);
  };
  dataURItoBlob(dataURI) {
    // convert base64 to raw binary data held in a string
    var byteString = atob(dataURI.split(',')[1]);
    // separate out the mime component
    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
    // write the bytes of the string to an ArrayBuffer
    var arrayBuffer = new ArrayBuffer(byteString.length);
    var _ia = new Uint8Array(arrayBuffer);
    for (var i = 0; i < byteString.length; i++) {
      _ia[i] = byteString.charCodeAt(i);
    }
    var dataView = new DataView(arrayBuffer);
    var blob = new Blob([dataView], { type: mimeString });
    return blob;
  }


  @Input() requirementCd: string = '';

  documentCollectionMiniMode: any = [];

  /* MINI VIEW Init() */
  /* This initializes the sub-data needed for MINI view; also sets the data arrays accordingly */
  initMiniView() {
    if (this.mode == 'mini' || this.mode == 'OCRView') {

      /* Check if all required inputs exists */
      if ((!this.requirementCd)) {
        console.log('Document Manager: ERROR!!! MINI mode --> All required inputs are mandatory !!!!!');
        return;
      }

      /* Get from existing doc list */
      let docSubListForMini = this.documentCollection.filter(i => i.requirements.requirementCd == this.requirementCd);
      /* If it doesnt exist, inject it */
      if (!docSubListForMini || docSubListForMini.length == 0) {
        docSubListForMini = this.addUploadRowCustomReq(this.requirementCd, false);
      }
      docSubListForMini = this.documentCollection.filter(i => i.requirements.requirementCd == this.requirementCd);
      console.log("Setting Data for Mini View ----", docSubListForMini);
      this.documentCollectionMiniMode = docSubListForMini;

      this.documentCollectionMiniMode.forEach((d, index) => {
        let category = d.requirements.requirementCd;
        d.documents = this.documentsFromServerMini.filter(i => i.documentTypeCd == category && i.clientRefGuid == this.clientRefGuid); //CHANGE LOGIC HERE (Filter data for MINI view)
        // Remove used docs from main list (filter !=)
        ///this.documentsFromServer = this.documentsFromServer.filter(i=>i.documentTypeCd!==category && i.clientRefGuid!==this.clientRefGuid); //CHANGE LOGIC HERE (Filter data for MINI view)
      });


    }
  }

  /* Force string conversion */
  toStr(val) {
    return String(val);
  }


  /* ====================== OCR  =========================== */

  @Input() ocrVerification: any = null;

  ngOnChanges(changes: SimpleChanges) {
    const ocrVer: SimpleChange = changes.ocrVerification;
    if (!!ocrVer) {
      //console.log('OCR DATA Prev: ', ocrVer.previousValue);
      console.log('OCR DATA Changed: ', ocrVer.currentValue);
      this.OCRInputModelsHaveChanged();
    }
  }

  /* Bank CHEQUE Upload */
  showUploadList = {
    showPreviewIcon: true,
    showRemoveIcon: true,
    hidePreviewIconInNonImage: true
  };
  fileList = [{
    uid: 1,
    name: 'xxx.png',
    status: 'done',
    url: "https://bse2nse.com/images/cancelled_cheque.png"
  }];
  previewImage: string | undefined = '';
  previewVisible = false;
  handlePreview = (file: NzUploadFile) => {
    this.previewImage = file.url || file.thumbUrl;
    this.previewVisible = true;
  };


  /* If any of the inputs that affect OCR component has changed, we need to reset it */
  OCRReady = true;
  OCRInputModelsHaveChanged() {
    this.OCRReady = false;
    this.setDataToBeVerifiedByOCR();
    setTimeout(() => { this.OCRReady = true }, 100);
  }

  /* OCR */
  OCRfileImage: string = 'https://bse2nse.com/images/cancelled_cheque.png'; /* Dummy Default for DEMO */
  handleFileUploadChange(e: any) {
    console.log("handleFileUploadChange", e.type);
    switch (e.type) { /* e.type：start, progress, success, removed */
      case 'removed':
        this.OCRInputModelsHaveChanged();
        break;
      case 'error':
      case 'success':
        this.setDataToBeVerifiedByOCR();
        this.OCRfileImage = e.file.url || e.file.thumbUrl;
        break;
    }
  }
  OCRverificationData: Array<any> = [];
  setDataToBeVerifiedByOCR() {
    this.OCRverificationData = this.ocrVerification;
  }


  dynamicSort = function (property) {
    return function (a, b) {
      return (a[property] < b[property]) ? -1 : (a[property] > b[property]) ? 1 : 0;
    }
  };

  /* Update visibility with new one for all files matching type,subType */
  updateVisibility = function (documentTypeCd, documentSubTypeCd, visibilityCd) {
    this.documentCollection.forEach((d, index) => {
      if (d.documents.length) {
        for (let i = 0; i < d.documents.length; i++) {
          if (d.documents[i].documentTypeCd == documentTypeCd && d.documents[i].documentSubTypeCd == documentSubTypeCd) {
            d.documents[i].visibilityCd = visibilityCd;
          }
        }
      }
    });
    this.dataHasChanged();
  };
  /* Update status with new one for all files matching type,subType */
  updateStatus = function (documentTypeCd, documentSubTypeCd, statusCd) {
    this.documentCollection.forEach((d, index) => {
      if (d.documents.length) {
        for (let i = 0; i < d.documents.length; i++) {
          if (d.documents[i].documentTypeCd == documentTypeCd && d.documents[i].documentSubTypeCd == documentSubTypeCd) {
            d.documents[i].documentStatusCd = statusCd;
          }
        }
      }
    });
    this.dataHasChanged();
  };
  /* Update Date */
  updateDate = function (documentTypeCd, documentSubTypeCd, date) {
    let dateVal = new Date(date).setHours(0, 0, 0, 0).valueOf();
    console.log("Setting date for set: ", documentTypeCd, documentSubTypeCd, date);
    this.documentCollection.forEach((d, index) => {
      if (d.documents.length) {
        for (let i = 0; i < d.documents.length; i++) {
          if (d.documents[i].documentTypeCd == documentTypeCd && d.documents[i].documentSubTypeCd == documentSubTypeCd) {
            d.documents[i].documentRecievedDt = dateVal
          }
        }
      }
    });
    this.dataHasChanged();
  };

  /* Received Date */
  dateArray: any = [];
  dateChange(date, index) {
    this.documentCollection[index]['requirements'].receivedDt = new Date(date).valueOf();
    this.dataHasChanged();
  }

  /* Loose Docs Received Date */
  dateArrayLoose: any = [];

  /* Simple change detection */
  notificationMessage = null;
  dataChanged: boolean = false;
  dataHasChanged = function (requirementCd?, dc?, status?) {
    this.dataChanged = true;
    this.splitModePreview=true
    //this.checkDocumentStatus(dc); // commented on 14/07
    requirementCd = this.sanitizeName(requirementCd);
    if (requirementCd && status == "RECEIVED")
      (this.notificationMessage == null) ? (this.notificationMessage = requirementCd + ",") : (this.notificationMessage = this.notificationMessage + requirementCd + ",")
  };

  /* Check if WAIVED */
  isWaived(i) {
    i = String(i).toLowerCase();
    return (i == 'waived' || i == 'waved'); // Possible values sent from server
  }
  /* Check if WAIVED */
  isOrdered(i) {
    i = String(i).toLowerCase();
    return (i == 'ordered' || i == 'orderd'); // Possible values sent from server
  }
  /* Check if IDENTIFIED */
  isIdentified(i) {
    i = String(i).toLowerCase();
    return (i == 'identified' || i == 'identified' || i == 'indentified'); // Possible values sent from server (yes, even 'indentified')
  }
  /* Check if RECEIVED */
  isReceived(i) {
    i = String(i).toLowerCase();
    return (i == 'received' || i == 'recieved'); // Possible values sent from server
  }

  /* Check if requirement is related to "nominee" or "client" */
  clientGuidToBeShown(cd) {
    return this.isNomineeRelated(cd) || this.isClientRelated(cd);
  }
  isNomineeRelated(cd) { return String(cd).toUpperCase().includes("NOMINEE") }
  isClientRelated(cd) { return String(cd).toUpperCase().includes("CLIENT") }
  isClaimantRelated(cd) { return String(cd).toUpperCase().includes("CLAIMANT") }

  /* NEW REQUIREMENT */
  unsavedNewRequirement: boolean = false;
  modalNewRequirement: boolean = false;
  newReqTemp: any = {
    userRequirement: null,
    statusCd: this.defaultStatusCd,
    visibilityCd: this.userIsExternal ? this.defaultVisibilityCdExternalUser : this.defaultVisibilityCd,
    identifedDt: new Date(),
    requestedDt: null,
    orderingNotes: null,
    remarks: null,
  };
  newReqTempBackup: any = Object.assign({}, this.newReqTemp); // Copy object for resetting

  createNewReq() {

    /* Null check */
    if (!this.newReqTemp.userRequirement) {
      this.msg.error(`Invalid Requirement specified`);
      return;
    }

    /* Check if same requirement already exists */
    if (this.documentCollection.filter((dc) => { return (dc.requirements.requirementCd == this.newReqTemp.userRequirement) }).length) {
      this.msg.error(`Requirement '` + this.sanitizeName(this.newReqTemp.userRequirement) + `' already exists`);
      return;
    }

    let identifiedDate = this.newReqTemp.identifedDt ? this.newReqTemp.identifedDt.valueOf() : new Date();

    let req = new RequirementDO();
    req.entityGuid = this.RequirementEntityGuid;
    req.requirementCd = this.newReqTemp.userRequirement;
    req.clientRefGuid = this.newReqTemp.clientRefGuid;
    req.status = this.newReqTemp.statusCd;
    req.identifiedBy = this.userId || "USER"; // Logged-in user's ID; defaults to "USER"
    req.appliesToCd = this.entity.toUpperCase(); // CLAIM
    /* Dates */
    req.identifedDt = identifiedDate;
    req.requestedDt = this.newReqTemp.requestedDt ? this.newReqTemp.requestedDt.valueOf() : identifiedDate; // Defaults to identified date
    /* Resolve By */
    req.resolveByStageCd = this.newReqTemp.resolveByStageCd;
    req.remarks = this.newReqTemp.remarks; // Remark (general)
    /* orderingNotes */
    req.orderingNotes = this.newReqTemp.orderingNotes; // Remark (in case of 'other' requirementCd)

    console.log("NEW REQUIREMENT: ", req);

    /* Create in Document Manager's structure * /
    let dc = {
      requirements: req,
      documents: [],
    };
    this.documentCollection.unshift(dc); // Insert to top
    /* */

    /* Reset variables */
    this.unsavedNewRequirement = true;
    this.modalNewRequirement = false; // Close modal
    this.isReady = false;

    /* Loader (pseudo) */
    this.msg.loading("Generating New Requirement", { nzDuration: 1000, nzAnimate: true, nzPauseOnHover: false });

    /* Save Requirements API Call */
    //this.saveRequirements(); // Changed to new api call below
    // Code copy-pasted again (for requirement/createUserReq) call
    this.apiRequestService.postCallWithAPIMapper('createUserReq', req).subscribe(respRequirements => {
      console.log("Requirement Save response", respRequirements);
      if (respRequirements) {
        console.log("Reqirement Save sucessful. Re-init() with new Reqs array (single req response inserted)");
        this._requirements.unshift(respRequirements); // Insert to top
        this.initDocumentData(null, this._requirements);
        /* RESET VARS */
        this.isSaving = false;
        this.unsavedNewRequirement = false;
        /* Reset ReqTemp */
        this.newReqTemp = Object.assign({}, this.newReqTempBackup); // Copy object for resetting
      }
    });
  }

  isSaving: boolean = false;
  /* Save both Requirements and Documents */
  saveReqsAndDocs() {

    /* VALIDATE OP before save */
    let errorCount = this.validateOutput();
    if (this.validationOutput.isInvalid) {
      this.validationOutput.errorDOs.forEach(eDO => {
        console.log('ERROR DO DOC MAN', eDO);
        this.msg.error(eDO.errorMsg);
      });
      return;
    }

    this.msg.loading("Saving document details", { nzDuration: 1000, nzAnimate: true, nzPauseOnHover: false });
    this.saveRequirements();
    this.saveDocuments();
    this.isReady = false;
    this.dataChanged = false;
  }

  /* Save Requirements */
  saveRequirements() {
    this.isSaving = true;
    let req = this.extractRequirementDOs();
    if (!req) return;
    this.apiRequestService.postCallWithAPIMapper('requirementSave', req).subscribe(respRequirements => {
      console.log("Reqirement Save response", respRequirements);
      if (respRequirements) {
        console.log("Reqirement Save sucessful. Re-init() with new Reqs");
        this._requirements = respRequirements;
        let data = null;
        this.initDocumentData(data, this._requirements);
        /* RESET VARS */
        this.isSaving = false;
        this.unsavedNewRequirement = false;
      }
    });
  }

  /* Save Documents */
  saveDocuments() {
    this.isSaving = true;
    let documentDOs = this.extractDocumentDOs();
    if (!!documentDOs && documentDOs.length) {
      this.apiRequestService.postCallWithAPIMapper('documentSave', documentDOs).subscribe(d => {
        console.log("Document Save response", d);
        let data = null;
        this.initDocumentData(data, this._requirements);
        /* RESET VARS */
        this.isSaving = false;
      });
    }
  }

  /* Date Fns */
  disabledDate = (current: Date): boolean => {
    let today = moment(new Date());
    let currentDate = moment(current);

    /* Intimation date */
    if (this.ioStartDate) {
      return !(currentDate.isBetween(this.ioStartDate, today));
    }
    else {
      /* Future Date disable */
      let diff = today.diff(currentDate, 'days', true);
      return !(diff > 0);
    }
    /* PS: Using (!)NOT because we want to disable dates that is NOT part of criteria */
  };

  /* Set Start Date (intimation Date) */
  setStartDate(dateArr) {
    if (Array.isArray(dateArr) && dateArr.length >= 3) {
      this.ioStartDate = String(dateArr[0]) + "-" + String(dateArr[1]) + "-" + String(dateArr[2]);
      console.log("Setting ioStartDate ------ ", this.ioStartDate);
    }
  }


  /* Hide for External User */
  hideForExternalUser(req) {
    let shouldHide = false;
    if (this.userIsExternal) { // Applicable only for external user
      if (req.visibilityCd == 'EXTERNAL') shouldHide = false; //If external, dont hide
      if ((req.visibilityCd == 'INTERNAL') && !(this.subTransactionGuids.find(id => id == req.subTransactionGuid))) shouldHide = true; // If internal & subTransactionGuid not found, hide
    }
    return shouldHide;
  }

  viewDocumentInSplitMode(imageURL) {
    this.verifyDocumentWithOCR(imageURL, 'preview', true);
  }

  enabledDelete: boolean = true;
  enabledDeleteDocumentBtn() {
    let DO = this._getDOName();
    if (this.io && this.io[DO] && this.io[DO]['statusCd'] == 'CONVERTED') {
      this.enabledDelete = false;

    } else if (this.io && this.io[DO] && this.io[DO]['adjudicationLevel'] == 2) {
      this.enabledDelete = false;
    }
    return this.enabledDelete;
  }


  preventNewDocument = false;
  checkUser() {
    this.userId = this.userInfoService.getUserId();
    let DO = this._getDOName();
    let branchUser = this.getBranchUser();
    let hoUser = this.getHOUser();
    if (this.appMetadataHandler.featureFlags.blockSaveForOtherUsers) {
      if (this.io && this.io[DO]) {
        if (this.userId !== this.io[DO].currentTaskUser) {
          this.preventNewDocument = true;
        } else {
          this.preventNewDocument = false;
        }
        // below condition is added to anable document save to branch user if the intimation is/was created by the same branch user.
        if (branchUser == true || hoUser == true) {
          this.preventNewDocument = false;
        }
      }
    }
    return this.preventNewDocument;
  }

  getBranchUser(isBranchUser?) {
    if (this.userLoggedIn && this.commonUtilty.isArrayIterable(this.userLoggedIn.userRoleDOList)) {
      let user = this.userLoggedIn.userRoleDOList.filter(item => (item.roleId == "BRANCH_USER"))
      if (this.commonUtilty.isArrayIterable(user)) {
        isBranchUser = true;
      }
      else isBranchUser = false
    }
    return isBranchUser
  }

  getHOUser() {
    if (this.userLoggedIn && this.commonUtilty.isArrayIterable(this.userLoggedIn.userRoleDOList)) {
      let user = this.userLoggedIn.userRoleDOList.findIndex(item => (item.roleId == "HO"))
      if (user != -1) return true
      else return false
    }
  }

  _getDOName() {
    return this.io ? this.io['proposalDO'] ? 'proposalDO' : 'caseDO' : 'proposalDO';
  }

  deleteFile(file, source?) {
    console.log("received obj file: ", file);
    console.log("document list: ", this.documentCollection)
    let documentToDelete = null
    let deletedDocReq, dcIndex;
    this.documentCollection.forEach((doc, parentIndex) => {
      if(doc.requirements.requirementCd === file.documentTypeCd){
          if(this.commonUtilty.isArrayIterable(doc.documents)){
            doc.documents.forEach((document,index) => {
              if(file.guid === document.guid){
                documentToDelete = document;
                doc.documents.splice(index,1)
                deletedDocReq = doc;
                dcIndex = parentIndex;
              }
            });
          }
        }
    });

    if(source){
      this.documentCollectionLoose.forEach((looseDoc, parentIndex) => {
        if(looseDoc.requirements.requirementCd === file.documentTypeCd){
          if(this.commonUtilty.isArrayIterable(looseDoc.documents)){
            looseDoc.documents.forEach((document,index) => {
              if(file.guid === document.guid){
                documentToDelete = document;
                looseDoc.documents.splice(index,1)
                deletedDocReq = looseDoc;
                dcIndex = parentIndex;
              }
            });
          }
        }
      });

      this.documentCollection.forEach((element, parentIndex) => {
        if (element.requirements.requirementCd === "ADDITIONAL_CLAIM_DOCUMENTS"){
          if(this.commonUtilty.isArrayIterable(element.documents)){
            element.documents.forEach((doc, index) => {
              if(file.guid === doc.guid){
                element.documents.splice(index,1)
                // deletedDocReq = element;
                // dcIndex = parentIndex;
              }
            });
          }
        }
      });

      if(this.commonUtilty.isArrayIterable(file)){
        this.documentCollection.forEach((item, parentIndex)=>{
          if(item.requirements.requirementCd === "ADDITIONAL_CLAIM_DOCUMENTS" && this.commonUtilty.isArrayIterable(item.documents)){
            item.documents.forEach((doc,index)=>{
              file.forEach(ele =>{
                if(doc.guid == ele.guid){
                  item.documents.splice(index,1)
                  deletedDocReq = item;
                  dcIndex = parentIndex;
                }
              })
            })
          }
        })
      }
    }
    
    if (deletedDocReq && !deletedDocReq.documents.length && deletedDocReq.requirements) {
      let req = deletedDocReq.requirements;
      req.receivedDt = null;
      this.updateDateOnStatusChange(dcIndex, 'documentCollection', req.status);
      this.dataHasChanged(req.description, deletedDocReq, req.status);
    }

    if(documentToDelete){
      this.apiRequestService.getCallWithAPIMapper('documentDeleteById/'+ documentToDelete.id).subscribe(d =>console.log("Document Save response", d));
    }
  }

  // document collection
  updatedDCStatusesDates = [];
  // document collection loose
  updatedDCLooseStatusesDates = [];
  updateDateOnStatusChange(index: number, type: string, status: string) {
    if ((index !== null && index !== undefined) && type && status) {
      switch (type) {
        case 'documentCollection':
          if (!this.commonUtilty.isArrayIterable(this.updatedDCStatusesDates)) {
            this.updatedDCStatusesDates = this.commonUtilty.deepCopy(Array(this.documentCollection.length).fill({status: null, date: null}));
          }
          if (this.commonUtilty.isArrayIterable(this.documentCollection)
              && this.updatedDCStatusesDates.length === this.documentCollection.length) {
            this.updatedDCStatusesDates[index]['status'] = status;
            this.dateArray[index] = new Date().valueOf();
            this.updatedDCStatusesDates[index]['date'] = this.dateArray[index];
          }
          break;
        case 'documentCollectionLoose':
          // no need for date change if status is "RECEIVED", will be changed manually
          if (status == 'RECEIVED') {
            this.dateArrayLoose[index] = null;
            return;
          }
          if (!this.commonUtilty.isArrayIterable(this.updatedDCLooseStatusesDates)) {
            this.updatedDCLooseStatusesDates = this.commonUtilty.deepCopy(Array(this.documentCollectionLoose.length).fill({status: null, date: null}));
          }
          if (this.commonUtilty.isArrayIterable(this.documentCollectionLoose) 
              && this.updatedDCLooseStatusesDates.length === this.documentCollectionLoose.length) {
            this.updatedDCLooseStatusesDates[index]['status'] = status;
            this.dateArrayLoose[index] = new Date(); // using new Date().valueOf() threw an error in the response to /document/save
            this.updatedDCLooseStatusesDates[index]['date'] = this.dateArrayLoose[index];
          }
          break;
      }
    }
  }
}


